import React, { useEffect, useState } from "react";
import EventCalendar from "./EventCalendar";
import EventList from "./EventList";
import { FaEnvelope } from "react-icons/fa";
import SocialIcon from "./SocialIcon";
import "../shared.css";

const CalendarSection = () => {
  const [events, setEvents] = useState([]);
  const [highlightedDate, setHighlightedDate] = useState(null);
  const [viewingMonth, setViewingMonth] = useState(new Date());

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await fetch("/api/calendar");
        const data = await res.json();
        setEvents(data);
      } catch (err) {
        console.error("Failed to fetch calendar events:", err);
        setEvents([]);
      }
    };

    fetchEvents();
  }, []);

  return (
    <section
      className="upcoming-events-section"
      role="region"
      aria-labelledby="upcoming-events-heading"
    >
      <h2 id="upcoming-events-heading" className="upcoming-events-header">
        Upcoming Events
      </h2>
      <p className="calendar-subtitle">
        Want to see us at an event?{" "}
        <a
          href="mailto:boop@danggoodleather.com"
          className="calendar-email-link"
          aria-label="Email us"
        >
          Email us! <FaEnvelope className="calendar-email-icon" />
        </a>
      </p>
      <div className="calendar-appearance-grid">
        <div className="calendar-wrapper">
          <EventCalendar
            events={events}
            highlightedDate={highlightedDate}
            onHighlightDate={setHighlightedDate}
            currentDate={viewingMonth}
            onDateChange={setViewingMonth}
          />
        </div>
        <div className="appearance-list-wrapper">
          <EventList
            events={events}
            highlightedDate={highlightedDate}
            viewingMonth={viewingMonth}
          />
        </div>
      </div>
    </section>
  );
};

export default CalendarSection;
